import { render, staticRenderFns } from "./QLGeneraleVeicoli.vue?vue&type=template&id=187a83fa&"
import script from "./QLGeneraleVeicoli.vue?vue&type=script&lang=js&"
export * from "./QLGeneraleVeicoli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports